// extracted by mini-css-extract-plugin
export default {"image":"WinterImage_image__2YEWn"};